<template>
    <v-card class="mt-2 ml-2 mr-2">
        <FCvptTable class="pl-2 pr-2" ref="refCvptTable"/>
    </v-card>
  </template>
  
  <script>
  import FCvptTable from "@/components/admin-umkm-type/FUmkmTypeTable.vue";
  
  export default {
    name: "CvptView",
    components: {
      FCvptTable
    },
    data() {
      return {
        tabTitle: 'Cvpt'
      }
    },
    computed: {
    },
    methods: {
      tabCvptClick(){
        this.$refs.refCvptTable.fetchParent()
      },
  
    },
  
  
  }
  </script>
  
  <style scoped>
  </style>